// extracted by mini-css-extract-plugin
export var rgpdContainer = "rgpd-module--rgpd-container--9b795";
export var rgpdSubTitle = "rgpd-module--rgpd-sub-title--f1ef2";
export var rgpdTitle = "rgpd-module--rgpd-title--0f69f";